export default __webpack_public_path__ + "static/media/notes.121b1c6a.webp";